import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { LoginFlow } from "../../shared/auth/LoginFlow";
import { guard } from "../../shared/auth/guards";
import { validateLoginSearch } from "../../shared/auth/search";

export const Route = createFileRoute("/portal/login")({
  validateSearch: validateLoginSearch,
  beforeLoad: async (args) => {
    await Promise.all([guard("guestOwner", args), loadNamespaces("auth")]);
  },
  component: OwnerLogin,
});

function OwnerLogin() {
  const { redirect, notice } = Route.useSearch();
  return <LoginFlow audience="owner" redirect={redirect} notice={notice} />;
}
